export const NAME = "core";

export const routes = {
    main: '/'
};

export const mediaBreakpoints = {
    mobile: 320,
    tablet: 768,
    computer: 992,
    largeScreen: 1200,
    widescreen: 1920
};